import axiosClient from './client';

export const integrateSupporterAccounts = ({ userId, plaidPublicToken, plaidInstitutionId, plaidAccountIdForWithdrawalAccount = null }) => (
  axiosClient().post(`/supporters/${userId}/integrate_accounts/`, {
    plaidPublicToken,
    plaidInstitutionId,
    plaidAccountIdForWithdrawalAccount
  })
)
